export function getScrollTop() {
	const scrollEl = document.scrollingElement || document.documentElement;
	return scrollEl.scrollTop;
}